import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    <span>Data Migrators</span>&nbsp;Documents
  </Header>
);

export default CustomHeader;
